import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ValidationResult {
  componentId: number;
  formValue: any;
  isValid: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SiblingValidationService {
  private validateSubject = new Subject<void>();
  validate$ = this.validateSubject.asObservable();

  private validationResultSubject = new Subject<ValidationResult[]>();
  validationResult$ = this.validationResultSubject.asObservable();

  private results: ValidationResult[] = [];

  triggerValidation() {
    this.results = [];
    this.validateSubject.next();
  }

  reportValidation(componentId: number, formValue: any, isValid: boolean) {
    if (!this.results.find((result) => result.componentId === componentId)) {
      this.results.push({ componentId, formValue, isValid });
    }
    // personal - 1
    // residence - 2
    // income - 3
    // accounts - 4
    // identification - 5
    if (this.results.length === 5) {
      this.validationResultSubject.next(this.results);
    }
  }
}
